import ContactEmail from "@/views/permits/RockCrushing/ContactEmail.vue";
import SiteInfo from "@/views/permits/RockCrushing/SiteInfo.vue";
import AcceptedMaterials from "@/views/permits/RockCrushing/AcceptedMaterials.vue";
import Signature from "@/views/permits/RockCrushing/Signature.vue";
import Review from "@/views/permits/RockCrushing/Review.vue";
import RenewalReview from "@/views/permits/RockCrushing/RenewalReview.vue";

export default {
    ContactEmail,
    SiteInfo,
    AcceptedMaterials,
    Signature,
    Review,
    RenewalReview
}